export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12119.eab05689.jpg";